function activateForm(form) {
    if (!form) return;

    const submitButton = document.querySelector('.js-form-submit');
    if (submitButton) {
        submitButton.disabled = false;
    }

    const validationField = document.createElement('input');
    validationField.name = 'js-validated';
    validationField.type = 'hidden';
    validationField.value = form.dataset.validationToken;

    form.appendChild(validationField);

    // eslint-disable-next-line no-param-reassign
    form.action = `#form?token=${form.dataset.validationToken}`;
}

export default function initForm() {
    const form = document.querySelector('.js-form');
    if (!form) {
        return;
    }

    setTimeout(() => {
        const subscriberInput = form.querySelector('#subscriber');
        if (subscriberInput) {
            subscriberInput.addEventListener('focus', (event) => {
                if (event.isTrusted) {
                    activateForm(form);
                }
            }, {once: true});
        }
    }, 2000);

    // Falls "Subscriber" durch Autofill gefüllt wurde,
    // prüfen wir ob die "Akzeptieren" Checkbox manuell angeklickt wurde
    setTimeout(() => {
        const acceptTermsCheckbox = form.querySelector('[name=terms]');
        if (acceptTermsCheckbox) {
            acceptTermsCheckbox.addEventListener('click', (event) => {
                if (event.isTrusted) {
                    activateForm(form);
                }
            }, {once: true});
        }
    }, 5000);

    // Resubmit des Formulars nach Fehlermeldung erlauben
    if (form.querySelector('.error-message')) {
        const answerElements = form.querySelectorAll('[name="answer"]');
        if (answerElements) {
            answerElements.forEach((element) => {
                element.addEventListener('focus', (event) => {
                    if (event.isTrusted) {
                        activateForm(form);
                    }
                }, {once: true});
            });
        }
    }
}
